export default "__VITE_ASSET__CCzjWuP___"